<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Vouchers', route: '/backoffice/vouchers/' }, { label: 'Aggiungi Voucher', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Aggiungi voucher</h1>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formVoucher" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <div>
                <h2>Dati voucher</h2>
                <span class="ac-meta">cliente, credito e codice</span>
            </div>
        </div>

        <div class="flex lg:flex-row flex-col gap-4">
            <div class="fld flex-1">
                <label>* Cliente</label>
                <input type="text" pInputText class="w-full" placeholder="Cliente" formControlName="cliente" required />
                @if (formVoucher.get('cliente')?.hasError('required') && (formVoucher.get('cliente')?.dirty || formVoucher.get('cliente')?.touched)) {
                    <small class="text-red-600 block mt-2 font-medium">Il cliente è obbligatorio.</small>
                }
            </div>
            <div class="fld flex-1">
                <label>Email</label>
                <input type="email" pInputText class="w-full" placeholder="Email" formControlName="email" name="email" id="email" />
                @if (formVoucher.get('email')?.hasError('email') && (formVoucher.get('email')?.dirty || formVoucher.get('email')?.touched)) {
                    <small class="text-red-600 block mt-2 font-medium">L'email deve essere valida.</small>
                }
            </div>
            <div class="fld flex-1">
                <label>Telefono</label>
                <input type="text" pInputText class="w-full" placeholder="Telefono" formControlName="telefono" />
            </div>
        </div>

        <div class="flex lg:flex-row flex-col gap-4">
            <div class="fld flex-1">
                <label>* Credito</label>
                <p-inputNumber formControlName="credito" mode="currency" currency="EUR" locale="it-IT" [maxFractionDigits]="2" styleClass="w-full" inputStyleClass="w-full" />
                @if (formVoucher.get('credito')?.hasError('required') && (formVoucher.get('credito')?.dirty || formVoucher.get('credito')?.touched)) {
                    <small class="text-red-600 block mt-2 font-medium">Il credito è obbligatorio.</small>
                }
            </div>
            <div class="fld flex-1">
                <label>* Codice</label>
                <input type="text" pInputText class="w-full" placeholder="Codice" formControlName="codice" />
                @if (formVoucher.get('codice')?.hasError('required') && (formVoucher.get('codice')?.dirty || formVoucher.get('codice')?.touched)) {
                    <small class="text-red-600 block mt-2 font-medium">Il codice è obbligatorio.</small>
                }
            </div>
            <div class="fld flex-1">
                <label>Data scadenza</label>
                <p-calendar formControlName="data_scadenza" dateFormat="dd/mm/yy" [showIcon]="true" [minDate]="minDate" styleClass="w-full" appendTo="body" />
            </div>
        </div>

        <div class="acc-actions">
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/vouchers">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formVoucher.valid">Aggiungi voucher</button>
        </div>
    </form>
</section>
